import { useEffect } from 'react';
import { debugMode } from './services/debugHelper';
import Box from '@mui/material/Box';
import AppRoutes from './components/AppRoutes';

function App() {
  useEffect(() => {
    debugMode();
  }, []);

  return (
    <div className="App">
      <Box sx={{ display: 'flex' }}>
        <AppRoutes />
      </Box>
    </div>
  );
}

export default App;
